// Demo-Weg (Spitzenniveau-Runde, Block 4, 12.10.2026): Nach dem Absenden sieht das Umzugsunternehmen
// die Eckdaten des Berichts, den Bericht als PDF und den Weg zum kostenlosen Test. Die Aufnahme wird
// nach 24 Stunden gelöscht, Mails gibt es keine.

import { useEffect } from "react";
import { API_URL } from "../api.ts";
import { useDraft, useStore } from "../hooks.ts";

const REGISTRIEREN = "https://app.umzugsscan.app/registrieren?von=demo";
const zahl = (n: number, d = 1) => n.toLocaleString("de-DE", { maximumFractionDigits: d });

export function DemoErgebnis() {
  const d = useDraft();
  const store = useStore();
  const r = d.demo?.result ?? null;
  const grenze = d.demo?.tagesgrenze ?? false;
  const wartet = !r && !grenze;

  // Während der Auswertung alle 4 Sekunden nachsehen.
  useEffect(() => {
    if (!wartet) return;
    const t = window.setInterval(() => void store.refresh(), 4000);
    return () => window.clearInterval(t);
  }, [wartet, store]);

  return (
    <section className="ergebnis">
      {wartet ? (
        <div className="danke">
          <div className="spinner" style={{ margin: "0 auto 16px" }} aria-label="Bericht wird erstellt" />
          <h1>Der Bericht wird erstellt</h1>
          <p>Die Fotos werden gerade ausgewertet. Das dauert meist ein bis zwei Minuten; die Seite aktualisiert sich selbst.</p>
        </div>
      ) : grenze ? (
        <div className="danke">
          <h1>Heute sind alle Demo-Auswertungen vergeben</h1>
          <p>
            Ihre Aufnahme ist angekommen, wird heute aber nicht mehr ausgewertet. Einen vollständigen Bericht sehen Sie im{" "}
            <a href="https://umzugsscan.app/beispielbericht">Beispielbericht</a>.
          </p>
        </div>
      ) : (
        <>
          <div className="danke">
            <div className="check-big" aria-hidden="true">
              ✓
            </div>
            <h1>So sieht der Bericht für Ihre Firma aus</h1>
            <p>Diese Eckdaten bekommen Sie zu jeder Aufnahme, mit Ihren eigenen Werten für Kartons, Team und Fahrzeuge.</p>
          </div>
          <div className="kacheln zwei">
            <div className="kachel">
              <b>ca. {r!.volumeText} m³</b>
              <span>Volumen</span>
            </div>
            <div className="kachel">
              <b>{r!.boxes}</b>
              <span>Umzugskartons</span>
            </div>
            <div className="kachel">
              <b>{zahl(r!.weightKg / 1000)} t</b>
              <span>Gewicht</span>
            </div>
            <div className="kachel">
              <b>{zahl(r!.manHours)} h</b>
              <span>Mannstunden</span>
            </div>
          </div>
          {r!.hints.length > 0 && (
            <section className="card">
              <h2>Hinweise im Bericht</h2>
              <ul className="hinweise">
                {r!.hints.map((h) => (
                  <li key={h}>{h}</li>
                ))}
              </ul>
            </section>
          )}
          <a className="btn btn-secondary btn-wide" href={`${API_URL}/erfassung/${encodeURIComponent(d.token)}/demobericht.pdf`} target="_blank" rel="noopener">
            Ganzen Bericht als PDF ansehen
          </a>
        </>
      )}

      <section className="card demo-cta">
        <h2>Für Ihre Kunden, mit Ihrem Logo</h2>
        <p>Ihre Kunden bekommen Ihren eigenen Link, Sie bekommen den Bericht per E-Mail. Die ersten 3 Aufnahmen sind kostenlos, ohne Zahlungsdaten.</p>
        <a className="btn btn-primary btn-wide" href={REGISTRIEREN}>
          3 Aufnahmen kostenlos testen
        </a>
      </section>
      <p className="hint">Diese Demo-Aufnahme und ihre Fotos werden nach 24 Stunden gelöscht.</p>
    </section>
  );
}
